var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('va-edit-layout',{attrs:{"title":_vm.title}},[(_setup.item)?_c('collections-form',{attrs:{"id":_vm.id,"title":_vm.title,"item":_setup.item}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }